export enum CreateBankConnectionModalSteps {
  Confirmation = 'confirmation',
  Processing = 'processing',
  SuccessNewFlow = 'success_new_flow',
  Error = 'error',
}
